import HotDeals  from '../@containers/HotDeals';
import NameSearch  from '../@containers/NameSearch';
import TagSearch  from '../@containers/TagSearch';
import SearchComponent from './Search.Component';
import DefaultComponent from './Default.Component';
import { Routes, Route } from 'react-router-dom';

const Main = () => {
    return ( 
        <Routes>
        <Route path='/' element={<NameSearch/>} />
        <Route path='/camgirl-search' element={<TagSearch/>} />
        <Route path='/camgirl-hot-deals' element={<HotDeals/>} />
        <Route path='/model/:site/:model' element={<SearchComponent/>} />
        <Route path='*' element={<DefaultComponent />} />
      </Routes>        
    );
 }
export default Main;